(function ($) {
	// Accordion initialization for a single inner-faq-block
	function initFaq($block) {
		var $buttons = $block.find(".faq-header button");
 
		$buttons.each(function () {
			var $button = $(this);
			var target = $button.data("target");
			var $collapse = $block.find(target);
			var $icon = $button.find("i");

			// Start collapsed
			$collapse.css({
				"max-height": "0px",
				overflow: "hidden",
			});

			// Click handler
			$button.off("click").on("click", function () {
				var isOpen =
					$collapse[0].style.maxHeight &&
					$collapse[0].style.maxHeight !== "0px";

				// Close all other FAQ items in this block
				$block
					.find(".faq-header button")
					.not($button)
					.each(function () {
						var otherTarget = $(this).data("target");
						var $otherCollapse = $block.find(otherTarget);
						var $otherIcon = $(this).find("i");

						$otherCollapse.css("max-height", "0px");
						$otherIcon.removeClass("rotate-180");
					});

				// Toggle current FAQ
				if (isOpen) {
					$collapse.css("max-height", "0px");
					$icon.removeClass("rotate-180");
				} else {
					$collapse.css("max-height", $collapse[0].scrollHeight + "px");
					$icon.addClass("rotate-180");
				}
			});
		});
	}

	// Initialize all inner-faq-blocks on page load
	$(function () {
		$(".inner-faq-block").each(function () {
			initFaq($(this));
		});
	});
})(jQuery);
